import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import errorIcon from "../../../assets/icons/errorIcon.svg"
import { convertToLocalCurrency } from "../../../utils/currency";
import {
  createCampaignPayment,
  getBill,
} from "../../../redux/slices/campaignSlice";

import billIcon from "../../../assets/icons/billIcon.svg";
import checkIcon from "../../../assets/icons/check.svg";
import copyIcon from "../../../assets/icons/copy.svg";
import uploadIcon from "../../../assets/icons/upload.svg";
import {
  FormWrapper,
  Container,
  RadioGroup,
  RadioButton,
  RadioLabel,
  ProofOfPaymentContainer,
  Details,
  FileInputLabel,
  FileInput,
  PreviewImage,
} from "./BillTabStyles";

const BillTab = () => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState("bank_transfer");
  const [proofOfPayment, setProofOfPayment] = useState(null);
  const [campaignBudget, setCampaignBudget] = useState(null);
  const [userID, setuserID] = useState(null);
  const [campaignID, setCampaignID] = useState(null);
  //console.log(campaignBudget);

  const { loading, bill, budget, userId, campaignId } = useSelector((state) => state.campaign);

  

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // useEffect(() => {
    
  // })

  useEffect(() => {
    dispatch(getBill());
    const storedBudget = localStorage.getItem("campaignBudget");
    const storeduserID = localStorage.getItem("userId");
    const storedcampaignId = localStorage.getItem("campaignId");
    if (storedBudget && storeduserID && storedcampaignId) {
      setCampaignBudget(JSON.parse(storedBudget));
      setuserID(JSON.parse(storeduserID));
      setCampaignID(JSON.parse(storedcampaignId));
    }
    if (budget && userId && campaignId) {
      setCampaignBudget(budget);
      setuserID(userId);
      setCampaignID(campaignId);
      localStorage.setItem("campaignBudget", JSON.stringify(budget));
      localStorage.setItem("userId", JSON.stringify(userId));
      localStorage.setItem("campaignId", JSON.stringify(campaignId));
    }
  }, [dispatch, budget, userId, campaignId]);

  //console.log(userID, campaignID);

  const currentBudget = convertToLocalCurrency(campaignBudget);

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  const handlePaymentMethodChange = (event) => {
    setSelectedPaymentMethod(event.target.value);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProofOfPayment(file);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (loading) return;

    const formData = new FormData();
    formData.append("userId", userID);
    formData.append("campaignBudget", campaignBudget);
    formData.append("campaignId", campaignID);
    if (proofOfPayment) {
      formData.append("files", proofOfPayment);
    }
    else {
      //console.log("File not found")
      Swal.fire({
        title: "Oops..",
        html: "Proof of payment is required",
        icon: null, 
      iconHtml:
          `<img src=${errorIcon} alt="error" style="width:50px;">`,
        confirmButtonText: "Okay",
      });
      return
    }
    
    //console.log(formData);
    try {
      //return
      await dispatch(createCampaignPayment(formData)).unwrap();
      navigate('/billing');
    } catch (error) {
      console.error("Failed to submit payment:", error);
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit}>
      <FormWrapper>
          <div>
            <label>Monthly campaign budget</label>
            <p>This is your budget for this month’s campaign</p>
          </div>
          <input
            type="text"
            //placeholder="$3,000"
            value={currentBudget}
            //onChange={(e) => setCampaignBudget(e.target.value)}
            readOnly
          />
        </FormWrapper>

        <FormWrapper>
          <div>
            <label>Choose payment method</label>
            <p>Choose how you want to make payment for this campaign</p>
          </div>
          <RadioGroup>
            <RadioButton
              type="radio"
              id="bank_transfer"
              name="payment_method"
              value="bank_transfer"
              checked={selectedPaymentMethod === "bank_transfer"}
              onChange={handlePaymentMethodChange}
            />
            <RadioLabel htmlFor="bank_transfer">
              <div className="label-name">
                <img src={billIcon} alt="Icon" />
                <p>Bank transfer</p>
              </div>
              <div className="circle">
                <img src={checkIcon} alt="" />
              </div>
            </RadioLabel>
            <RadioButton
              type="radio"
              id="cryptocurrency"
              name="payment_method"
              value="cryptocurrency"
              disabled
              readOnly
            />
            <RadioLabel htmlFor="cryptocurrency">
              <div className="label-name">
                <img src={billIcon} alt="Icon" />
                <p>Cryptocurrency (coming soon)</p>
              </div>
              <div className="circle">
                <img src={checkIcon} alt="" />
              </div>
            </RadioLabel>
          </RadioGroup>
        </FormWrapper>

        <FormWrapper>
          <div>
            <label>ClickCircle Account Details</label>
            <p>This will be displayed on your profile.</p>
          </div>

          <Details>
            <div className="wrapper">
              <div>
                <label>Bank name</label>
                <p>{bill[0]?.bankName}</p>
              </div>
              <img
                src={copyIcon}
                alt="Copy"
                onClick={() => handleCopy(bill[0]?.bankName)}
              />
            </div>

            <div className="wrapper">
              <div>
                <label>Account number</label>
                <p>{bill[0]?.accountNumber}</p>
              </div>
              <img
                src={copyIcon}
                alt="Copy"
                onClick={() => handleCopy(bill[0]?.accountNumber)}
              />
            </div>

            <div className="wrapper">
              <div>
                <label>Account name</label>
                <p>{bill[0]?.accountName}</p>
              </div>
              <img
                src={copyIcon}
                alt="Copy"
                onClick={() => handleCopy(bill[0]?.accountName)}
              />
            </div>

            <div className="wrapper">
              <div>
                <label>Amount</label>
                <p>{currentBudget}</p>
              </div>
              <img
                src={copyIcon}
                alt="Copy"
                onClick={() => handleCopy(campaignBudget)}
              />
            </div>
          </Details>
        </FormWrapper>

        <FormWrapper>
          <div>
            <label>Proof of payment</label>
            <p>Please upload a receipt of your completed transaction</p>
          </div>
          <ProofOfPaymentContainer>
            <FileInputLabel htmlFor="proof_of_payment">
              {proofOfPayment ? (
                <PreviewImage
                  src={URL.createObjectURL(proofOfPayment)}
                  alt="Proof of Payment"
                />
              ) : (
                <div className="text">
                  <img src={uploadIcon} alt="" />
                  <p>Click to upload</p>
                  {/* <small>PNG, JPG</small> */}
                </div>
              )}
              <FileInput
                type="file"
                id="proof_of_payment"
                //accept=".svg,.png,.jpg"
                onChange={handleFileChange}
              />
            </FileInputLabel>
          </ProofOfPaymentContainer>
        </FormWrapper>

        <div className="submit">
          <div></div>
          <div className="submit-buttons">
            <Link to='/campaigns'>
            <button className="cancel" type="submit" disabled={loading}>
              Pay Later
            </button></Link>
            <button className="add-campaign" type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </Container>
  );
};

export default BillTab;
